// src/utils/rent.js
/* eslint-disable */

// Devuelve true si la fila/DTO representa una maquina alquilada.
export function hasRent(m) {
  if (!m) return false;

  const rentObj = m.Rent;
  if (rentObj) {
    const active = rentObj.IsActive !== false;
    if (!active) return false;
    if (rentObj.Id != null) return true;
  }

  // LocalMachine.RentId/LocalMachineRentId es la relacion historica autoritativa.
  const rentId = m.RentId ?? m.LocalMachineRentId ?? null;
  const rentIsActive = m.RentIsActive ?? m.Rent?.IsActive ?? null;
  if (rentId != null && rentIsActive !== false) return true;

  return false;
}

// En un detalle persistido, RentId es el dato historico autoritativo.
export function hasHistoricalRent(m) {
  return m?.RentId != null;
}

// Precio de alquiler (numero) o null
export function getRentPrice(m) {
  if (!m) return null;
  const v = m?.Rent?.Price ?? m?.RentPrice ?? null;
  const n = v != null ? Number(v) : null;
  return Number.isFinite(n) ? n : null;
}

// Frecuencia (mensual, etc.) o ""
export function getRentFrequency(m) {
  if (!m) return "";
  return m?.Rent?.PaymentFrequency ?? m?.RentPaymentFrequency ?? "";
}

// Objeto Rent normalizado (incluyendo IsActive) o null
export function getRent(m) {
  if (!hasRent(m)) return null;
  return {
    Id: m?.Rent?.Id ?? m?.RentId ?? m?.LocalMachineRentId ?? null,
    Price: getRentPrice(m),
    PaymentFrequency: getRentFrequency(m),
    IsActive: m?.Rent?.IsActive ?? m?.RentIsActive ?? true,
  };
}
